/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Err_NumberInputs */

const en_messages_err_number = /** @type {(inputs: Messages_Err_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That number doesn’t look valid.`)
};

const he_messages_err_number = /** @type {(inputs: Messages_Err_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המספר הזה לא נראה תקין.`)
};

/**
* | output |
* | --- |
* | "That number doesn’t look valid." |
*
* @param {Messages_Err_NumberInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_err_number = /** @type {((inputs?: Messages_Err_NumberInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Err_NumberInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_err_number(inputs)
	return he_messages_err_number(inputs)
});